"use strict";
exports.__esModule = true;
var react_1 = require("react");
function useEventCallback(fn) {
    var ref = react_1.useRef();
    react_1.useLayoutEffect(function () {
        ref.current = fn;
    });
    return react_1.useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return ref.current.apply(null, args);
    }, []);
}
exports["default"] = useEventCallback;
//# sourceMappingURL=useEventCallback.js.map